import { createSlice } from '@reduxjs/toolkit';

const serverIPSlice = createSlice({
  name: 'serverIP',
  initialState:{ serverIPs: [] },
  reducers: {
    addServerIp: (state, action) => {
      if (!state.serverIPs.includes(action.payload)) {
        state.serverIPs.push(action.payload);
      }
    },
    clearServerIps: (state) => {
      state.serverIPs = [];
    },
  }
});

export const { addServerIp, clearServerIps } = serverIPSlice.actions;
export const selectServerIP = (state) => state.serverIP.serverIPs;

export default serverIPSlice.reducer;